import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { get750RemValue } from 'base/utils/dom-size';
import styles from './index.module.less';
import { IBanner, IFeatureWaterFall } from 'mod/feature/interface'
import titleStyles from 'app/styles/modules/title.module.less'
import homeStyles from '@app/shop/index.module.less'
import ModuleTitle from '@base/lib/ModuleTitle'
import { getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features'
import Image from '@base/lib/ThemeImage';
import Link from '@base/lib/ThemeLink';
import { useTrans } from 'base/utils/i18n';

declare interface IProps {
    data: IFeatureWaterFall;
}

const CONTAINER_WIDTH = process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 750 : 1200; //容器最大宽度

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const WatterFall: React.FC<IProps> = (props) => {
    const { data } = props
    const moduleCode = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);

    const [pageNum, setPageNum] = useState<number>(1)
    const [showList, setShowList] = useState<IBanner[][]>([])
    const { t } = useTrans();

    const {
        config: {
            column = 2,
            height = 200,
            spaceBetweenColumns = 20,
            viewMoreText = `${t('web_common_view_more')} >`,
            pageSize = 6,
        },
        lists,
    } = data;

    const imageWidth = Math.round((CONTAINER_WIDTH + spaceBetweenColumns) / column) - spaceBetweenColumns;

    const imageHeight = height || 200;
    const fullColumnSpace = isPhone ? get750RemValue(spaceBetweenColumns) : `${spaceBetweenColumns}px`
    const halfColumnSpace = isPhone ? get750RemValue(spaceBetweenColumns / 2) : `${spaceBetweenColumns / 2}px`

    // 分成几组
    const columnLengthArr = Array.from({ length: column }, (_, i) => i);


    const getShowList = () => {
        let _showList = lists.slice(0, pageNum * pageSize)
        // 将list分成 column 组
        const columnList = columnLengthArr.map((groupItem, groupIndex) => {
            return _showList.map((item, lIndex) => {
                return { ...item, lIndex }
            }).filter((lItem, lIndex) => {
                return lIndex % column == groupIndex
            })
        })

        setShowList(columnList)
    }

    useEffect(() => {
        getShowList()
    }, [pageNum])

    return (
        <div id={moduleElementId}
             data-t-mod={moduleCode}
             className={homeStyles.wrapper}
             style={getWrapStyle(data)}
        >
            <div>
                <ModuleTitle
                    className={cn(titleStyles.title, homeStyles.title)}
                    text={data.title}
                    link={data.readMoreLink}
                    linkText={data.readMoreTitle}
                    moduleCode={moduleCode}
                />

                <div
                    className={styles.list}
                    style={{
                        marginLeft: `-${halfColumnSpace}`,
                        marginRight: `-${halfColumnSpace}`,
                        rowGap: fullColumnSpace
                    }}
                >
                    {showList?.map((cItem, cIndex) => (
                        <div key={cIndex} className={`column${cIndex}`}
                             style={{
                                 width: `${100 / column}%`,
                                 paddingLeft: halfColumnSpace,
                                 paddingRight: halfColumnSpace,
                             }}
                        >
                            {cItem?.map((item, index) => {
                                return (
                                    <div
                                        key={`${cIndex}_${index}`}
                                        className={styles.item}
                                        style={{
                                            marginTop: index != 0 ? fullColumnSpace : 0
                                        }}
                                    >
                                        <Link href={item.linkUrl ? item.linkUrl : 'javascript:void(0);'}>
                                            <Image
                                                className={'pointer'}
                                                fit={'cover'}
                                                src={item.picUrl}
                                                width={imageWidth}
                                                height={(cIndex % 2 == 1 && index == 0) ? imageWidth : imageHeight}
                                            />
                                        </Link>

                                    </div>
                                )
                            })}
                        </div>

                    ))}
                </div>

                {pageNum * pageSize < lists.length && (
                    <div className={cn(styles['view-more-wrap'],'text-center')}>
                        <span
                            className={cn(styles['view-more'], 'g-waterfall-view-more pointer')}
                            onClick={() => setPageNum(pageNum + 1)}
                        >{viewMoreText}</span>
                    </div>
                )}

            </div>
        </div>
    );
};

export default React.memo(WatterFall);